<div class="relative">
  <div class="overflow-hidden">
    <img src="/images/grid-image/image-01.png" alt="Cover"
      class="w-full border border-gray-200 rounded-xl dark:border-gray-800" />
  </div>
</div>